import app, { Component } from 'apprun';
import { isValidElement } from '../utils';
import { users } from '../api';

export default class UserPropertyUsernameComponent extends Component {

  view = (state) => {
    if (!state.item) {return;}
    return (
      <div>
        <form class="form-horizontal" style={{ width: '450px' }}>
          <div class="row">
            <div class="col-sm-12">{state.item.dispName}</div>
            <div class="col-sm-12">
              <input
                id="inpText"
                size="62"
                class="form-control"
                value={state.newVal}
                oninput={(e) => {
                  state.newVal = e.target.value;
                }}
              />
            </div>
          </div>
          <div class="col-sm-12">
            <a href="" class="block mt1 hand" onclick={() => this.run('checkAvailability')}>
              <i class="fa fa-eye mr1" />
              &nbsp; Check Availability Now
            </a>
          </div>
          <br/>
          <div id="inpTextErrMsg" class="text-danger">{state.availabilityMessage}</div>
          <div class="edit-buttons">
            <a
              type="button"
              class="btn btn-primary btn-xs"
              style={
                state.item.required || state.item.value === ''
                  ? { display: 'none' }
                  : { display: 'inline-block' }
              }
              onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
              delete
            </a>
            <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
              save
            </a>
            <a
              type="button"
              class="btn btn-default btn-xs"
              onclick={() => state.caller.run(state.cancel, state.panelId)}>
              cancel
            </a>
          </div>
        </form>
        <div>
          {
            state.auditLog
              ?
              <div>
                <p>Update History</p>
                <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
                  <thead>
                    <tr>
                      <th>Username</th>
                      <th>Modified Date</th>
                      <th>Modified User</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.auditLog.map((log) => {
                      return (
                        <tr style={{ display: 'table-row' }}>
                          <td>{log.userName}</td>
                          <td>{log.modifiedDate?.substring(0, 10)}</td>
                          <td>{log.auditModifiedUser}</td>
                        </tr>
                      );
                    }
                    )}
                  </tbody>
                </table>
              </div>
              : ''
          }
        </div>
      </div>
    );
  };

  update = {
    refresh: async (state, newState) => {
      state = newState;

      state.newVal = state.item.value;
      state.availabilityMessage = '';
      state.auditLog = await users.getAuditUserName(state.personId);

      return state;
    },
    save: (state) => {
      if (!state.newVal) {return;}

      if (state.item.fieldName === 'DCS ID') {state.item.validation = 'Max7dInteger';}

      if (isValidElement('inpText', state.item.validation)) {
        state.caller.run(state.save, state.item, state.panelId, state.newVal);
      }
    },

    checkAvailability: async (state) => {
      const username = (document.getElementById('inpText') as HTMLInputElement).value;

      if (username.length === 0) {
        state.availabilityMessage = 'Username cannot be empty';
        return state;
      }

      const userEmail = username + '@royallepage.ca';
      const isAvailable = await users.checkEmailAvailability(userEmail);

      if (isAvailable) {
        state.availabilityMessage = `${userEmail} is available`;
      } else {
        state.availabilityMessage = `${userEmail} is unavailable`;
      }

      return state;
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
